export const FilterIcon = () => (
  <svg fill="none" height="9" viewBox="0 0 8 8" width="9" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 0.499999C0 0.223857 0.223858 0 0.5 0H7.5C7.77614 0 8 0.223858 8 0.5V1.68996C8 1.8043 7.96081 1.91518 7.88897 2.00413L5.31103 5.19587C5.23919 5.28482 5.2 5.3957 5.2 5.51004V7.5C5.2 7.77614 4.97614 8 4.7 8H3.3C3.02386 8 2.8 7.77614 2.8 7.5V5.51004C2.8 5.3957 2.76081 5.28482 2.68897 5.19587L0.111029 2.00413C0.0391869 1.91518 0 1.8043 0 1.68996V0.499999Z"
      fill="#B8CBE6"
    />
  </svg>
);
